import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AUTHORIZATION_HEADER_NAME,
  CSRF_COOKIE_NAME,
  TOKEN_KEY
} from '@app/core/services/auth.constants';
import { LocalStorageService } from '@app/core/services/local-storage.service';
import { UserDataService } from '@app/core/services/user-data.service';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Token {
  value: string;
}

@Injectable()
export class AuthService {

  constructor(private http: HttpClient,
    private localStorage: LocalStorageService,
    private cookieService: CookieService,
    private userDataService: UserDataService) {
  }

  login({username, password}): Observable<any> {
    const body = {
      pfusermodel: {
        logonId: username
      },
      password
    };

    return this.http.post('login', body, {observe: 'response'}).pipe(
      map(response => {
        if (response instanceof HttpResponse) {
          return this.getTokenFromHeaders(response);
        }
        return response;
      })
    );
  }

  authenticatedUser() {
    return this.userDataService.getUser();
  }

  saveToken(token: string) {
    this.localStorage.write(TOKEN_KEY, {value: token});
  }

  getToken(): string {
    const tokenObj = this.localStorage.read<Token>(TOKEN_KEY);
    return tokenObj && tokenObj.value;
  }

  removeToken() {
    this.localStorage.remove(TOKEN_KEY);
    this.cookieService.delete(CSRF_COOKIE_NAME);
  }

  private getTokenFromHeaders(response: HttpResponse<any>) {
    const token: string = response.headers.get(AUTHORIZATION_HEADER_NAME);

    return {token};
  }

}
